import $ from 'jquery';


$(document).ready(function() {
    let $activeSlide = $(".swiper-slide-active");
    let $titleElement = $activeSlide.find(".init_card__title");
    let titleText = $titleElement.text();
    $(".title-callout").text(titleText);
});

$(document).ready(function () {
    $('.accordion').on('click', function (event) {
        event.preventDefault();
        if (!$(this).hasClass('closed')) {
            return;
        }
        $('.accordion:not(.closed)').addClass('closed');
        $(this).removeClass('closed');
        $('.accordion').each(function () {
            this.open = false;
        });
        this.open = true;
    });
});